/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Id_LabelInputs */



/**
* | output |
* | --- |
* | "ID" |
*
* @param {Snapshot_History_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_id_label = /** @type {((inputs?: Snapshot_History_Id_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Id_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID")
	if (locale === "de") return /** @type {LocalizedString} */ ("AUSWEIS")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ИДЕНТИФИКАТОР")
	if (locale === "es") return /** @type {LocalizedString} */ ("IDENTIFICACIÓN")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहचान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("EU IA")
	return /** @type {LocalizedString} */ ("ID")
});